import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { ListItem } from "./ListItem";
import { ListContext } from "./ListContext";
import { ListDivider } from "./ListDivider";
export function List(_a) {
    var title = _a.title, footer = _a.footer, children = _a.children, className = _a.className, props = __rest(_a, ["title", "footer", "children", "className"]);
    return (React.createElement(View, __assign({ className: classNames("tea-list", className) }, props),
        typeof title !== "undefined" && (React.createElement(View, { className: "tea-list__title" }, title)),
        React.createElement(View, { className: classNames("tea-list__wrap", {
            // [`tea-hairline--${bordered || "horizontal"}`]: bordered,
            }) },
            React.createElement(ListContext.Provider, { value: {} }, children)),
        typeof footer !== "undefined" && (React.createElement(View, { className: "tea-list__footer" }, footer))));
}
List.Item = ListItem;
List.Divider = ListDivider;
//# sourceMappingURL=List.js.map